export default "__VITE_ASSET__82f31aca__"